const validateMessages = {
    loginField: "O campo Login é obrigatório.",
    passwordField: "O campo Senha é obrigatório.",
    confirmPasswordField: "O campo Confirmar senha é obrigatório.",
    cpfCnpjField: "O campo CPF/CNPJ é obrigatório.",
    usuarioField: "O campo Usuário é obrigatório.",
    campoObrigatorio: "Campo obrigatório.",
    tokenExpirado: "Link expirado ou inválido, realize nova solicitação de reset de senha.",
}

export {
    validateMessages
}
